<template>
  <v-data-table
    dense
    hide-default-footer
    fixed-header
    disable-sort
    disable-pagination
    :items="data"
    :headers="headers"
    class="secondarybackground striped-table ma-2"
  >
    <template v-slot:item.id="{ item }">
      <copy-to-clipboard :message="item.id" />
    </template>
    <template v-slot:item.signalisation_datetime="{ item }">
      <div>
        {{ item.signalisation_datetime | showDate }}
      </div>
    </template>
    <template v-slot:item.customer_comment="{ item }">
      <copy-to-clipboard
        :message="item | showComment"
        :text-truncate-lenght="60"
      />
    </template>
    <template v-slot:item.status="{ item }">
      <div>
        {{ item | showStatus }}
      </div>
    </template>
    <template v-slot:item.technician_fullname="{ item }">
      <div v-if="item.technician_fullname">
        {{ item.technician_fullname }} ({{ item.technician_phone }})
      </div>
    </template>
  </v-data-table>
</template>

<script>
import CopyToClipboard from '@/components/tools/CopyToClipboard';
import { mapGetters } from 'vuex';
import { REQUEST_STATES } from '@/store/modules/requests/treated';

export default {
  name: 'RequestRecurrenceTable',
  components: { CopyToClipboard },
  props: {
    data: {
      type: Array,
      required: true,
    },
    onlyClosed: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  filters: {
    showDate(date) {
      return date && date.toLocaleString();
    },
    showStatus(item) {
      if (item.rejected === 'O') {
        return 'Rejetée';
      }
      if (item.status === '5' || item.status === '9') {
        return item.reason_to_be_continued ? 'Terminée à suivre' : 'Terminée';
      }
      return REQUEST_STATES.find((state) => state.id === item.status).name;
    },
    showComment(item) {
      if (item.rejected === 'O') {
        return item.rejection_comment;
      }
      return item.customer_comment;
    },
  },
  data: () => ({
    headers: [
      { text: 'Numéro', value: 'id' },
      { text: 'Date signalisation', value: 'signalisation_datetime' },
      { text: 'Symptômes', value: 'work_order_group_type_name' },
      { text: 'Qualification', value: 'work_order_group_qualif_name' },
      { text: 'Commentaire', value: 'customer_comment' },
      { text: 'Etat', value: 'status' },
      { text: 'Technicien', value: 'technician_fullname' },
      { text: 'Observation', value: 'report_desc' },
    ].map((item) => {
      return { ...item, align: 'center', class: 'secondarybackground' };
    }),
  }),
  computed: {
    ...mapGetters({
      reasonsToBeContinued: 'requests/reasonsToBeContinued/items',
      rejectionTypes: 'requests/rejectionTypes/items',
    }),
  },
};
</script>

<style scoped lang="scss">
@import '@/styles/table.scss';

.striped-table {
  max-width: 9000px;
}

.striped-table ::v-deep table > thead {
  display: inline-block;
}

.striped-table ::v-deep table > thead th {
  width: 15%;
}

.striped-table ::v-deep table > thead th:nth-child(1) {
  width: 10%;
}

.striped-table ::v-deep table > thead th:nth-child(5) {
  width: 12000px;
}

.striped-table ::v-deep table > tbody {
  display: inline-block;
  max-height: 350px;
  overflow-y: auto;
}

.striped-table ::v-deep table > tbody td {
  width: 15%;
}

.striped-table ::v-deep table > tbody td:nth-child(1) {
  width: 10%;
}
.striped-table ::v-deep table > tbody td:nth-child(5) {
  width: 12000px;
}
</style>
